/** @format */

import React, { Fragment } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import AuthLayout from "./AuthLayout";
import ClientLayout from "./ClientLayout";
import { useSelector } from "react-redux";
import MyDesktop from "../components/deviceViews/MyDesktop";
import MyMobile from "../components/deviceViews/MyMobile";
import MobileView from "../components/mobileView";
import Loader from "../components/globalLoader";

const Layouts = {
  auth: AuthLayout,
  client: ClientLayout,
};

const Layout = ({ children }) => {
  const isUserAuthorized = useSelector((state) => state.userData?.authorized);
  const globalLoading = useSelector((state) => state.globalData?.globalLoading);
  const location = useLocation();
  const navigate = useNavigate();
  const pathname = location.pathname;

  const handleRedirection = ({
    pathname,
    stateObj = {},
    preserveSearch = false,
  }) => {
    const searchParams = preserveSearch ? location.search : "";
    navigate(`${pathname}${searchParams}`, {
      state: {
        ...stateObj,
      },
    });
  };

  const isPublicRoute = /^\/public-test\//i.test(pathname);

  // Layout Rendering
  const getLayout = () => {
    if (/^\/auth(?=\/|$)/i.test(pathname)) {
      return "auth";
    }
    return "client";
  };

  const Container = Layouts[getLayout()];
  let isAuthLayout = getLayout() === "auth";

  const BootstrappedLayout = () => {
    if (globalLoading) {
      return <Loader />;
    }

    if (!isAuthLayout && !isUserAuthorized && !isPublicRoute) {
      // Preserve query parameters when redirecting to login
      console.log("Redirecting to login with search params:", location.search);
      return handleRedirection({
        pathname: "/auth/login",
        preserveSearch: true,
      });
    }

    if (isPublicRoute) {
      return <>{children}</>;
    }

    return <Container>{children}</Container>;
  };

  return <Fragment>{BootstrappedLayout()}</Fragment>;
};

export default Layout;
